import type { SnakeCasedPropertiesDeep } from 'type-fest';
import type { payment } from '~/infra/api/rpc';
import { api } from '~/infra/api/teller-api';
import { PaymentPlatform, type PaymentSubscription } from '~/models/payment';

export type PaymentListProductRequest =
  SnakeCasedPropertiesDeep<payment.IPaymentListProductRequest>;
export type PaymentListProductResponse =
  SnakeCasedPropertiesDeep<payment.IPaymentListProductResponse>;

export type PaymentGetLatestSubscriptionRequest =
  SnakeCasedPropertiesDeep<payment.IPaymentGetLatestSubscriptionRequest>;

export type PaymentListActiveSubscriptionRequest =
  SnakeCasedPropertiesDeep<payment.IPaymentListActiveSubscriptionRequest>;
export type PaymentListActiveSubscriptionResponse =
  SnakeCasedPropertiesDeep<payment.IPaymentListActiveSubscriptionResponse>;

export type PaymentProductResponse =
  SnakeCasedPropertiesDeep<payment.IPaymentProduct>;

export type PaymentSubscriptionResponse =
  SnakeCasedPropertiesDeep<payment.IPaymentSubscription>;
const SERVICE_PATH = '/payment.PaymentService';

export const listProduct = async (
  req: payment.IPaymentListProductRequest
): Promise<PaymentListProductResponse> => {
  const { data } = await api.post(`${SERVICE_PATH}/ListProduct`, req);

  return data;
};

export const getLatestSubscription = async (
  req: PaymentGetLatestSubscriptionRequest
): Promise<PaymentSubscription> => {
  const { data } = await api.post(`${SERVICE_PATH}/GetLatestSubscription`, req);

  return data;
};

export const listActiveSubscriptions =
  async (): Promise<PaymentListActiveSubscriptionResponse> => {
    const req: PaymentListActiveSubscriptionRequest = {
      platform: PaymentPlatform.PAYMENT_PLATFORM_UNSPECIFIED,
    };

    const { data } = await api.post(
      `${SERVICE_PATH}/ListActiveSubscription`,
      req
    );

    return data;
  };
